// src/lib/services/contact.service.ts
import { omniApiClient } from "@oppy/omniv2-core";
function getContactDetails({
  entityId,
  contactId
}) {
  return omniApiClient.get(
    `${entityId}/contact/${contactId}/metadataintegration`
  );
}

// src/lib/services/rcs.service.ts
import { omniApiClient as omniApiClient2, omniApiClientOld } from "@oppy/omniv2-core";
function createRcsSettings({
  entityId,
  data
}) {
  return omniApiClientOld.post(`${entityId}/rcs/settings`, data);
}
function getRcsSettingsList({
  entityId,
  searchParams: params
}) {
  return omniApiClient2.get(`v2/${entityId}/rcs/settings`, { params });
}
function getRcsSettings({
  entityId,
  rcsSettingsId
}) {
  return omniApiClientOld.get(`${entityId}/rcs/settings/${rcsSettingsId}`);
}
function updateRcsSettings({
  entityId,
  rcsSettingsId,
  data
}) {
  return omniApiClientOld.put(
    `${entityId}/rcs/settings/${rcsSettingsId}`,
    data
  );
}
function deleteRcsSettings({
  entityId,
  rcsSettingsId
}) {
  return omniApiClient2.delete(`${entityId}/rcs/settings/${rcsSettingsId}`);
}
function getPaginatedCampaigns({
  entityId,
  payload
}) {
  return omniApiClient2.post(
    `${entityId}/campaign/fetchPaginatedCampaignsWithKPIs`,
    payload
  );
}
function getCampaignKpi({
  entityId,
  campaignId
}) {
  return omniApiClient2.get(`${entityId}/campaign/${campaignId}/kpi`);
}

// src/lib/services/rcs-agent.service.ts
import { omniApiClient as omniApiClient3 } from "@oppy/omniv2-core";
function getAgentList({
  entityId,
  searchParams: params
}) {
  return omniApiClient3.get(`${entityId}/rcs/agents`, { params });
}
function createAgent({ entityId, data }) {
  return omniApiClient3.post(`${entityId}/rcs/agents`, data);
}
function activateAgent({ entityId, agentId }) {
  return omniApiClient3.put(`${entityId}/rcs/agents/${agentId}/activate`);
}
function getAgent({
  entityId,
  rcsAgentId
}) {
  return omniApiClient3.get(`${entityId}/rcs/agents/${rcsAgentId}`);
}

// src/lib/services/rcs-stats.service.ts
import { omniApiClient as omniApiClient4 } from "@oppy/omniv2-core";

// src/lib/services/service.helper.ts
function getBaseUrl(entityId) {
  return `${entityId}/rcs/campaigns/`;
}

// src/lib/services/rcs-stats.service.ts
function getStatsDeliverability({
  entityId,
  campaignId,
  searchParams
}) {
  return omniApiClient4.get(
    `${getBaseUrl(entityId)}${campaignId}/delivery/details?${searchParams}`
  );
}
function getStatisticsDeliverability({
  entityId,
  campaignId
}) {
  return omniApiClient4.get(
    `${getBaseUrl(entityId)}${campaignId}/delivery/statistics`
  );
}
function getStatusDeliverability({
  entityId
}) {
  return omniApiClient4.get(`${entityId}/rcs/statuses`);
}
function getGlobalStatistics({
  entityId,
  campaignId
}) {
  return omniApiClient4.get(
    `${entityId}/rcs/campaigns/${campaignId}/global/statistics`
  );
}
function getStatsUnsubscription({
  entityId,
  campaignId,
  searchParams
}) {
  return omniApiClient4.get(
    `v1/${entityId}/rcs/campaigns/${campaignId}/unsubscribes?${searchParams}`
  );
}
function getStatsEngagement({
  entityId,
  campaignId
}) {
  return omniApiClient4.get(
    `${getBaseUrl(entityId)}${campaignId}/engagement/statistics`
  );
}
function getStatsCTAEngagement({
  entityId,
  campaignId,
  searchParams
}) {
  return omniApiClient4.get(`${getBaseUrl(entityId)}${campaignId}/cta/details`, {
    params: searchParams
  });
}
function getCTAEngagement({
  entityId,
  campaignId
}) {
  return omniApiClient4.get(`${getBaseUrl(entityId)}${campaignId}/cta`);
}

// src/lib/services/api-adresse.service.ts
import { createClient, responseInterceptor } from "@oppy/omniv2-core";
var adresseClient = createClient({
  baseURL: import.meta.env.VITE_ADRESSEAPI_ENDPOINT
});
responseInterceptor(adresseClient);
function searchAdresse({
  searchParams: params
}) {
  return adresseClient.get("search", { params });
}

export {
  searchAdresse,
  getContactDetails,
  createRcsSettings,
  getRcsSettingsList,
  getRcsSettings,
  updateRcsSettings,
  deleteRcsSettings,
  getPaginatedCampaigns,
  getCampaignKpi,
  getAgentList,
  createAgent,
  activateAgent,
  getAgent,
  getStatsDeliverability,
  getStatisticsDeliverability,
  getStatusDeliverability,
  getGlobalStatistics,
  getStatsUnsubscription,
  getStatsEngagement,
  getStatsCTAEngagement,
  getCTAEngagement
};
